<template>
  <el-dialog title="Product List" :fullscreen="true" :visible.sync="pdfdialogVisible">
    <div style="margin-bottom: 100px; margin-top: 30px">
      <!--      <div ref="pdfContent" class="pdf-content" style="margin-bottom: 100px;height: 2000px;background-color: #005cc5">-->

      <div v-if="loading" class="loading-overlay">
        <p>{{ loadingMessage }}</p>
      </div>

      <div class="pdf-content">
        <span class="pdfName"></span>

        <!-- 产品信息 -->
        <el-button id="exportBtn" type="primary" icon="el-icon-notebook-2" size="small" @click="exportPdf"
          title="Export Product Pdf" :disabled="!productList.length">Export PDF</el-button>
        <div style="margin-top: 10px;" v-if="userinfo.company_logo!='https://pyk.a2z-deal.com' && userinfo.company_logo!=''">
          <el-input type="textarea"  :rows="3" placeholder="Please fill in the content here..." v-model="formContent"
            class="custom-textarea"></el-input>
        </div>
        <div ref="pdfContent" id="pdfContent">

          <div class="header-container" v-if="userinfo.company_logo!='https://pyk.a2z-deal.com' && userinfo.company_logo!=''">
            <div class="company-info">
              <div class="company-logo">
                <img width="50%" :src="userinfo.company_logo" alt="">
              </div>
              <!-- <div class="company-details">
                <div class="company-address">{{ userinfo.company_address }}</div>
                <div class="company-website">{{ userinfo.company_website }}</div>
              </div>
              <div class="services">
                <span class="service-item">{{ userinfo.company_service }}</span>
              </div>
              <div class="company-description">
                {{ userinfo.company_description }}
              </div> -->
            </div>
            <div class="form-area">
              <div class="form-title"></div>
              <div class="preview-container">{{ formContent }}</div>
            </div>
          </div>
              
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="pdfProductItem" v-for="(item) in productList"
            ref="pdfProductItem" :key="item.id">
            <!--            :ref="'pdfProductItem'+index"-->
            <div class="imgBox">
              <div v-for="(img, index) in item.images" :key="index" style="width: 20%">
                <img v-if="index < 3" :src="img" :key="index" />
              </div>
            </div>
            <div class="detailsInfo">
              <div class="topbox" style="margin-bottom: 20px">
                <span class="pdfName">{{ item.name }}</span>
                <span style="margin-left: 20px">{{ item.code }}</span>
              </div>
              <div class="pdfDescription">{{ item.describe }}</div>
              <div class="pdfPrice">
                <el-col :xs="10" :sm="10" :md="10" :lg="10" :xl="10" class="content-left">
                  <div class="pdfTitle">Quantity Break</div>
                  <el-table :data="item.price_data">
                    <el-table-column label="Quantity">
                      <template slot-scope="scope">{{ scope.row.quantity }}+</template>
                    </el-table-column>
                    <el-table-column label="Price">
                      <template slot-scope="scope">{{ currency_symbol }}{{ scope.row.delivered_price }}</template>
                    </el-table-column>
                  </el-table>
                </el-col>
                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="content-right">
                  <div class="material" v-if="item.material_str">
                    <div class="pdfTitle">MATERIAL</div>
                    <div class="pdfContent">{{ item.material_str }}</div>
                  </div>
                  <div class="printing-mode" v-if="item.imprint_str">
                    <div class="pdfTitle">PRINTING MODE</div>
                    <div class="pdfContent">{{ item.imprint_str }}</div>
                  </div>
                  <div class="printing-size" v-if="item.imprint_area">
                    <div class="pdfTitle">PRINTING SIZE</div>
                    <div class="pdfContent">{{ item.imprint_area }}</div>
                  </div>
                  <div class="color" v-if="item.color">
                    <div class="pdfTitle">COLOR</div>
                    <div class="pdfContent">{{ item.color }}</div>
                  </div>
                </el-col>
              </div>
            </div>
          </el-col>
          <!--          <p>&nbsp;</p>-->
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { imgToBase } from "@/api/placard";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { login } from "@/api/login";
import 'jspdf-autotable';
export default {
  props: {
    id: {
      type: String,
      default: "",
    },
    userinfo: {
      type: [Object, Array], // 允许多种类型
      default: () => ({})
    }
  },
  data() {
    return {
      pdfdialogVisible: false,
      productList: [],
      currency_symbol: '$',
      loading: false,
      loadingMessage: '',
      isbase: false,
      zancunH: [],
      formContent: '',
      /*imagesLoaded: 0,
      totalImages: 0,*/
    };
  },
  mounted() {
    
  },
  methods: {
    // 将图片URL数组转换为Base64编码数组
    async imageUrlsToBase64(urls) {
      try {
        const urlString = urls.join(',');
        const res = await imgToBase({
          no: urlString,
          link: window.location.href,
        });
        return res.data;
      } catch (error) {
        return urls.map(() => null); // 返回一个与urls等长的数组，值为null，以便继续处理
      }
    },
    isSplit(nodes, index, pageHeight) {
      if (nodes[index].offsetTop + nodes[index].scrollHeight < pageHeight && nodes[index + 1] && nodes[index + 1].offsetTop + nodes[index + 1].scrollHeight > pageHeight) {
        return true; // 节点被分割
      } else {
        return false; // 节点未被分割
      }
    },
    async exportPdf() {
      this.loading = true;
      this.loadingMessage = 'Please wait while PDF is being exported...';

      // 确保内容已加载完成
      await this.$nextTick();

      // 隐藏导出按钮
      const exportBtn = document.getElementById('exportBtn');
      if (exportBtn) exportBtn.style.display = 'none';
      // 转换所有产品图片为base64格式
      if (!this.isbase) {
        // 转换logo
        if (this.userinfo.company_logo) {
          this.userinfo.company_logo = await this.imageUrlsToBase64([this.userinfo.company_logo]);
        }

        const promises = [];
        this.productList.forEach((product) => {
          const imageUrls = product.images;
          const promise = this.imageUrlsToBase64(imageUrls).then((base64Images) => {
            // 确保 base64Images 数组与原来的 imageUrls 数组长度相同
            base64Images.forEach((base64Image, index) => {
              this.$set(product.images, index, base64Image);
            });
          });
          promises.push(promise);
        });

        // 等待所有图片转换完成
        await Promise.all(promises);
        this.isbase = true;

        // 确保DOM更新
        await this.$nextTick();
      }
      // 获取PDF内容容器
      const pdfContent = document.getElementById('pdfContent');

      // 计算A4纸尺寸（考虑边距）
      const A4_WIDTH_MM = 210;
      const A4_HEIGHT_MM = 297;
      const MARGIN_MM = 10;
      const CONTENT_WIDTH_MM = A4_WIDTH_MM - 2 * MARGIN_MM;
      const CONTENT_HEIGHT_MM = A4_HEIGHT_MM - 2 * MARGIN_MM;

      // 获取头部元素
      const headerElement = pdfContent.querySelector('.header-container');

      // 创建PDF实例
      const pdf = new jsPDF('p', 'mm', 'a4');
      let currentPageHeight = CONTENT_HEIGHT_MM;

      // 添加头部内容（只在第一页）
      if (headerElement) {
        const headerCanvas = await html2canvas(headerElement, {
          scale: 2,
          useCORS: true,
          allowTaint: true
        });

        const headerImgData = headerCanvas.toDataURL('image/jpeg');

        // 计算头部实际高度（保持原始比例）
        const headerAspectRatio = headerCanvas.width / headerCanvas.height;
        const headerWidthMM = CONTENT_WIDTH_MM;
        const headerHeightMM = headerWidthMM / headerAspectRatio;

        pdf.addImage(
          headerImgData,
          'JPEG',
          MARGIN_MM,
          MARGIN_MM,
          headerWidthMM,
          headerHeightMM
        );

        // 更新当前页剩余高度
        currentPageHeight -= headerHeightMM;

        // 添加头部与内容之间的间距
        const spacingMM = 5;
        currentPageHeight -= spacingMM;
      }

      // 获取所有产品项
      const productItems = Array.from(pdfContent.querySelectorAll('.pdfProductItem'));

      // 处理每个产品项
      for (const item of productItems) {
        const itemCanvas = await html2canvas(item, {
          scale: 2,
          useCORS: true,
          allowTaint: true
        });

        const itemImgData = itemCanvas.toDataURL('image/jpeg');

        // 计算产品项实际高度（保持原始比例）
        const itemAspectRatio = itemCanvas.width / itemCanvas.height;
        const itemWidthMM = CONTENT_WIDTH_MM;
        const itemHeightMM = itemWidthMM / itemAspectRatio;

        // 检查当前页剩余空间是否足够
        if (currentPageHeight < itemHeightMM) {
          // 添加新页
          pdf.addPage();
          currentPageHeight = CONTENT_HEIGHT_MM;
        }

        // 计算Y坐标（考虑页边距）
        const yPos = A4_HEIGHT_MM - currentPageHeight - MARGIN_MM;

        // 添加产品项到PDF
        pdf.addImage(
          itemImgData,
          'JPEG',
          MARGIN_MM,
          yPos,
          itemWidthMM,
          itemHeightMM
        );

        // 更新当前页剩余高度
        currentPageHeight -= itemHeightMM;

        // 添加产品项之间的间距
        const spacingMM = 5;
        currentPageHeight -= spacingMM;
      }

      // 保存PDF
      pdf.save('paperDownName.pdf');

      // 恢复UI状态
      this.loading = false;
      if (exportBtn) exportBtn.style.display = 'block';
    },
  },
};
</script>

<style>
.preview-container {
  margin-top: 125px;
  font-size: 10;
  color: #666;
  line-height: 25px;
  white-space: pre-line;
  /* 关键属性：保留换行 */

}

/* 新增头部样式 */
.header-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 40px;
  padding: 20px;
  width: 100%;
  /* border: 1px solid #eaeaea; */
  background-color: #fff;
}

.company-info {
  flex: 1;
  padding-right: 30px;
}

.company-logo {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}


.logo-text {
  color: white;
  font-weight: bold;
  font-size: 20px;
}

.years-text {
  background-color: #ffcc00;
  color: #333;
  padding: 5px 10px;
  border-radius: 3px;
  font-size: 14px;
  font-weight: bold;
}

.company-details {
  margin-bottom: 15px;
}

.company-name {
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 5px;
}

.company-website {
  color: #0069B4;
}

.company-address {
  font-size: 14px;
  color: #000;
  /* color: #666; */
  margin-bottom: 3px;
}

.services {
  margin-bottom: 10px;
}

.service-item {
  /* font-weight: bold; */
  /* color: #333; */
}

.service-divider {
  margin: 0 5px;
  color: #999;
}

.company-description {
  font-size: 14px;
  color: #666;
  /* font-style: italic; */
}

.form-area {
  flex: 1;
  max-width: 40%;
}

.form-title {
  color: #ff0000;
  font-weight: bold;
  margin-bottom: 10px;
  font-size: 16px;
}

.custom-textarea textarea {
  font-size: 14px;
  color: #333;
}

/**增加样式结束 */


.el-col {
  border-radius: 4px;
}

#pdfContent {
  display: flex;
  flex-wrap: wrap;
}

.pdfProductItem {
  font-size: 18px;
  border: solid 1px #aaa;
  padding: 40px;
  margin: 42px 0px;
}

.imgBox {
  width: 100%;
  margin-bottom: 10px;
  display: flex;
  flex-wrap: wrap;
}

.imgBox img {
  padding: 10px;
  height: auto;
  max-height: 300px;
  max-width: 18vw;
}

.pdfName {
  font-size: 46px;
  font-style: normal;
  font-weight: 700;
}

.pdfDescription {
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 1px;
}

.material {
  clear: both;
  margin-top: 20px;
}

.pdfPrice {
  margin-top: 50px;
  display: flex;
  flex-wrap: wrap;
}

.pdfPrice>div:first-child {
  margin-right: 30px;
}

.pdfPrice .el-table {
  font-size: 18px;
}

.pdfPrice .el-table thead {
  color: black;
  font-size: 20px;
  font-weight: 700;
}

.pdfTitle {
  font-weight: bold;
}

.pdfContent {
  font-style: normal;
  font-weight: 400;
  line-height: 40px;
}

.printing-mode {
  margin-top: 20px;
}

.printing-size {
  margin-top: 20px;
}

.pdf-content {
  background-color: white;
  padding: 20px;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 1.5em;
  z-index: 1000;
  /* 确保加载动画在最上层 */
}

@media only screen and (max-width: 768px) {
  .imgBox {
    margin-bottom: 5px;
  }

  .pdfProductItem {
    padding: 10px;
    font-size: 15px;
    margin: 20px 0;
  }

  .pdf-content {
    padding: 0;
  }

  .imgBox img {
    max-width: 80%;
    height: 58px;
    padding: 0;
  }

  .pdfName {
    font-size: 20px;
  }

  .pdfPrice {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
  }

  .pdfPrice>div:first-child {
    margin-right: 5px;
    font-size: 16px;

  }

  .pdfPrice .el-table {
    font-size: 15px;
  }

  .content-left {
    width: 60%;
  }

  .content-right {
    flex: 1;
  }

  .detailsInfo .topbox {
    margin-bottom: 5px !important;
  }

  .pdfDescription {
    line-height: 100%;
    font-size: 14px;
  }

  .pdfContent {
    line-height: 25px;
  }

  .el-table .el-table__cell {
    padding: 5px 0;
  }

  .printing-mode {
    margin-top: 0;
  }
}

@media only screen and (min-width: 769px) and (max-width: 1024px) {
  .pdfProductItem {
    padding: 10px;
  }

  .pdf-content {
    padding: 0;
  }

  .imgBox img {
    max-width: 95%;
  }

  .pdfName {
    font-size: 30px;
  }

  .pdfPrice>div:first-child {
    margin-right: 30px;

  }

  .pdfDescription {
    line-height: 150%;
  }
}
</style>
